"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _immutable = require("immutable");
var _createReducer = _interopRequireDefault(require("../helpers/createReducer.js"));
var _b2bPeerCalc = require("../helpers/b2bPeerCalc.js");
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var initialState = exports.initialState = new _immutable.List();
var reducers = {};
reducers[_constants.PERFORMANCE_PEERS_FETCHED] = function peerPerformancesFetched(state, payload) {
  var response = payload.response;
  var peerPerformances = (0, _b2bPeerCalc.peerMapper)(response);
  return peerPerformances;
};
reducers[_constants.QUESTION_BANK_SELECTED] = function () {
  return initialState;
};
reducers[_constants.SESSION_RESET] = function () {
  return initialState;
};
var _default = exports.default = (0, _createReducer.default)(reducers, initialState);